import Decimal from 'decimal.js';

import { ITradeDetails } from '../models/trade/i-trade-details.interface';

import { TradeContractType } from '../enums/market/trade-contract-type.enum';

import { useCurrency, useRMVCurrency, useUSDCCurrency } from './useCurrency';
import { useDecimalPrice } from './useDecimalPrice';
import { useStableExchangeRate } from './useStableExchangeRate';

export const useTradePrices = (tradeDetails: ITradeDetails) => {
  const usdcCurrency = useUSDCCurrency();
  const rmvCurrency = useRMVCurrency();
  const isAuctionHouse = tradeDetails.contract_type === TradeContractType.auctionHouse;
  const exchangeRate = useStableExchangeRate(
    tradeDetails.currency_id,
    tradeDetails.stable_exchange_rate || 0,
    isAuctionHouse
  );

  const usdcWeiPrice = +new Decimal(tradeDetails.price).times(exchangeRate).valueOf();
  const price = useDecimalPrice(+tradeDetails.price, tradeDetails.currency_id) || '-';
  const usdcPrice = useDecimalPrice(+usdcWeiPrice, usdcCurrency?.id) || '-';
  const currencyId = isAuctionHouse ? rmvCurrency?.id : tradeDetails.currency_id;
  const currency = useCurrency(currencyId);

  return {
    price,
    usdcPrice,
    isAuctionHouse,
    currency,
  };
};
